import React, { useContext, useEffect, useRef, useState } from 'react'
import MsgUtils from '../Tools/MsgUtils';
import Nav from 'react-bootstrap/Nav';
import DateConverter from '../Tools/DateConverter';
import { ContextGloball } from '../Context/ContextGlobal';
import { DownloadTableExcel } from 'react-export-table-to-excel';
import Modal from 'react-bootstrap/Modal';
const server = process.env.REACT_APP_SERVER;

function ReporteReuqerimiento() {
  const { setLoading } = useContext(ContextGloball);
  const tableRef = useRef();
  const [fechaIni, setFechaIni] = useState('');
  const [fechaFin, setFechaFin] = useState('');
  const [lista, setLista] = useState([]);
  const [ventana, setVentana] = useState(0);
  const [resumenInfo, setResumenInfo] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [selectLista, setSelectLista] = useState([]);
  function getPrioridad(priori) {
    if (priori == 'Z') {
      return <span className='w-100 badge fondoVerdeOscuro'>BAJA</span>
    } else if (priori == 'A') {
      return <span className='w-100 badge fondoRojo'>ALTA</span>
    } else if (priori == 'M') {
      return <span className='w-100 badge fondoMostasa'>MEDIA</span>
    } else if (priori == 'N') {
      return <span className='w-100 badge fondoNaranja'>NORMAL</span>
    } else if (priori == '0') {
      return <span className='w-100 badge fondoAzulMarino'>INMEDIATO</span>
    } else if (priori == '1') {
      return <span className='w-100 badge fondoVioleta'>CRITICA</span>
    }
  }
  function buscarInformacion() {
    if ((fechaIni != '' && fechaFin != '') || ventana == 0 || ventana == 3) {
      setLoading(true);
      fetch(`${server}/almacen/getSolicitudes`, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          fechaIni, fechaFin, 'regional': JSON.parse(localStorage.getItem("__react_session__")).regional, 'tipo': ventana
        })
      })
        .then(res => res.json())
        .then(data => {
          if (data.ok) {
            var valores = data.ok;
            if (ventana == 0) {
              valores.sort((a, b) => a.ID_SOLICITUD - b.ID_SOLICITUD)
            }
            if (ventana == 2) {
              var areas = [...new Set(valores.map(item => item.DEPARTAMENTO))]
              var nombres = [...new Set(valores.map(item => item.ID_EMPLEADO_COTIZA))]
              var pendientesList = valores.filter((item) => item.ESTADO !== 'B' && item.ESTADO !== 'N' && item.ESTADO !== 'D'&& item.ESTADO !== 'C'&&item.ESTADO !== 'E')
              var finalizadosList = valores.filter(item => item.ESTADO == 'B' || item.ESTADO == 'N' || item.ESTADO == 'D'|| item.ESTADO == 'C'||item.ESTADO == 'E')
              var listaCotizadores = []
              var listaAreas = []
              for (var ids of nombres) {
                listaCotizadores.push({ 'ID_EMPLEADO': ids, 'SOLICITUDES': valores.filter((item) => item.ID_EMPLEADO_COTIZA == ids) })
              }
              for (var are of areas) {
                listaAreas.push({ 'AREA': are, 'SOLICITUDES': valores.filter(item => item.DEPARTAMENTO == are) })
              }
              setResumenInfo({ 'PENDIENTES': pendientesList, 'FINALIZADOS': finalizadosList, 'COLABORADORES': listaCotizadores, 'AREAS': listaAreas })
            }
            setLista(valores);
            setLoading(false);
            console.log(data.ok[0])
          } else {
            setLoading(false);
            MsgUtils.msgError(data.error)
          }
        })
        .catch(error => MsgUtils.msgError(error));
    } else {
      MsgUtils.msgError("Elija las fechas para poder buscar")
    }
  }
  function getDiasPendientes(dato, fechaIni, fechaFin, estado) {
    var dateIni = new Date(Date.parse(fechaIni));
    var dateFin = new Date(Date.parse(fechaFin));
    var dias;
    if (dato == 'APR' || dato == 'CNC' || dato == 'ELM' || dato == 'COM' || estado == 'B') {
      dias = dateFin.getTime() - dateIni.getTime()
      return parseInt(dias / (1000 * 60 * 60 * 24))
    } else {
      dateFin = new Date()
      dias = dateFin.getTime() - dateIni.getTime()
      return parseInt(dias / (1000 * 60 * 60 * 24))
    }
  }
  function getMonto(datos, tipo) {
    if (ventana == 0 || ventana == 3) {
      if (datos.COTIZACION.length != 0) {
        return datos.COTIZACION[0].IMPORTE.toFixed(2);
      } else {
        return 0
      }
    } else if (ventana == 1) {
      if (datos.COMPRA.length != 0) {
        if (tipo == 'P' || tipo == 'G') {
          const totales = datos.COMPRA.map((item) => item.SUBTOTAL)
          const suma = totales.reduce((total, numero) => total + numero, 0);
          return suma.toFixed(1)
        } else if (tipo == 'A') {
          const totales = datos.COMPRA.map((item) => item.PRECIO_UNITARIO)
          const suma = totales.reduce((total, numero) => total + numero, 0);
          return suma.toFixed(1)
        }
      } else {
        return 0
      }
    }
  }
  function getInforResumenColab(tipo, lista) {
    if (tipo == true) {
      var aux = lista.filter(item => item.ESTADO != 'B' && item.ESTADO != 'N' && item.ESTADO != 'D'&& item.ESTADO != 'C'&&item.ESTADO !== 'E')
      return aux.length
    } else {
      var aux = lista.filter(item => item.ESTADO == 'B' || item.ESTADO == 'N' || item.ESTADO == 'D'|| item.ESTADO == 'C' ||item.ESTADO == 'E')
      return aux.length
    }
  }
  function comprobarSuspendido(valor) {
    if (ventana == 0 || ventana == 3) {
      if (ventana == 0) {
        return valor.SUSPENDIDO == 'N'
      } else {
        return valor.SUSPENDIDO == 'S'
      }
    } else {
      return true
    }
  }
  useEffect(() => {
    if (ventana == 0 || ventana == 3) {
      buscarInformacion();
    } else {
      setLista([])
    }
  }, [ventana])
  return (
    <>
      <div className='container-fluid bg-dark bg-gradient'>
        <Nav variant="tabs" activeKey={ventana} onSelect={(e) => setVentana(e)}>
          <Nav.Item>
            <Nav.Link bsPrefix='nav-link border' eventKey={0}><span className={`fw-bold text-center ${ventana == 0 ? 'text-dark' : 'bg-transparent text-secondary'}`}>PENDIENTES</span></Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link bsPrefix='nav-link border' eventKey={3}><span className={`fw-bold text-center ${ventana == 3 ? 'text-dark' : 'bg-transparent text-secondary'}`}>SUSPENDIDOS</span></Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link bsPrefix='nav-link border' eventKey={1}><span className={`fw-bold text-center ${ventana == 1 ? 'text-dark' : 'bg-transparent text-secondary'}`}>FINALIZADOS</span></Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link bsPrefix='nav-link border' eventKey={2}><span className={`fw-bold text-center ${ventana == 2 ? 'text-dark' : 'bg-transparent text-secondary'}`}>RESUMEN</span></Nav.Link>
          </Nav.Item>
        </Nav>
      </div>
      <div className='container-fluid bg-dark bg-gradient py-1'>
        <div className='row row-cols gx-1 g-1'>
          {ventana != 0 && ventana != 3 && <div className='col' style={{ minWidth: '170px', maxWidth: '170px' }}>
            <div className="input-group input-group-sm " >
              <span className="input-group-text bg-transparent text-light" style={{ border: 'none' }}>Fecha Ini</span>
              <input type="date" className="form-control" value={fechaIni} onChange={(e) => setFechaIni(e.target.value)} />
            </div>
          </div>}
          {ventana != 0 && ventana != 3 && <div className='col' style={{ minWidth: '170px', maxWidth: '170px' }}>
            <div className="input-group input-group-sm " >
              <span className="input-group-text bg-transparent text-light" style={{ border: 'none' }}>Fecha Fin</span>
              <input type="date" className="form-control" value={fechaFin} onChange={(e) => setFechaFin(e.target.value)} />
            </div>
          </div>}
          {ventana != 0 && ventana != 3 && <div className='col' style={{ minWidth: '100px', maxWidth: '100px' }}>
            <button className='btn btn-sm btn-secondary w-100' onClick={() => buscarInformacion()}>
              <i className="fa-solid fa-magnifying-glass"></i> Buscar
            </button>
          </div>}
          {(ventana == 0 || ventana == 3) && <div className='col' style={{ minWidth: '120px', maxWidth: '120px' }}>
            <button className='btn btn-sm btn-secondary w-100' onClick={() => buscarInformacion()}>
              <i className="fa-solid fa-magnifying-glass"></i> Actualizar
            </button>
          </div>}
          {ventana != 2 && <div className='col' style={{ minWidth: '100px', maxWidth: '100px' }}>
            <DownloadTableExcel
              filename={`compras${(ventana == 0 || ventana == 3) ? 'Pendientes' : 'Finalizados'}`}
              sheet={`${(ventana == 0 || ventana == 3) ? 'Pendientes' : 'Finalizados'}`}
              currentTableRef={tableRef.current}
            >
              <button className='btn btn-sm btn-success w-100'><i className="fa-solid fa-file-excel"></i> Excel</button>
            </DownloadTableExcel>
          </div>}
        </div>
      </div>
      {ventana != 2 && <div className='table-responsive'>
        <table className="table table-dark table-sm table-striped table-hover" ref={tableRef}>
          <thead className='text-center'>
            <tr>
              <th>#</th>
              <th>SOLICITADO</th>
              <th>PRIORIDAD</th>
              <th>DEPARTAMENTO</th>
              <th>ESTADO</th>
              {ventana == 0 && <th>PENDIENTE</th>}
              {ventana == 1 && <th>FINALIZADO</th>}
              <th>MONTO</th>
            </tr>
          </thead>
          <tbody className='text-center'>
            {lista.map((item, index) => {
              if (comprobarSuspendido(item)) {
                return (
                  <tr key={index}>
                    <td>{item.ID_SOLICITUD}</td>
                    <td>{DateConverter.formatoFecha(item.FECHA)}</td>
                    <td>{getPrioridad(item.PRIORIDAD)}</td>
                    <td>{item.DEPARTAMENTO}</td>
                    <td>{item.NAME_ESTADO}</td>
                    {ventana == 0 && <td>{getDiasPendientes(item.TIPO_SEG, item.FECHA, item.FECHA_SEG, item.ESTADO)} Dias</td>}
                    {ventana == 1 && <td>
                      <div>
                        {(item.TIPO_SEG == 'APR' || item.TIPO_SEG == 'CNC' || item.TIPO_SEG == 'ELM' || item.TIPO_SEG == 'COM' || item.ESTADO == 'B') ? DateConverter.formatoFecha(item.FECHA_SEG) : '-'}
                      </div>
                      <div className='text-center fw-bold'>
                        {getDiasPendientes(item.TIPO_SEG, item.FECHA, item.FECHA_SEG, item.ESTADO)} Dias
                      </div>
                    </td>}
                    <td>{getMonto(item, item.TIPO_COMPRA)} Bs</td>
                  </tr>
                )
              }
            })}
          </tbody>
        </table>
      </div>}
      {ventana == 2 &&
        <div className='container py-2'>
          <div className='card  bg-dark'>
            <div className='card-body'>
              <div className='row row-cols gx-1'>
                <div className='col'>
                  <div className="input-group mb-3">
                    <span className="input-group-text" id="basic-addon1">Nuevas<br></br>Solicitudes</span>
                    {resumenInfo.PENDIENTES != undefined && <input type="number" className="form-control"
                      style={{ fontSize: '22px', textAlign: 'center' }}
                      value={resumenInfo.PENDIENTES.length} disabled />}
                  </div>
                  <div className="input-group mb-3">
                    <span className="input-group-text" id="basic-addon1">Finalizadas</span>
                    {resumenInfo.FINALIZADOS != undefined && <input type="number" className="form-control"
                      style={{ fontSize: '22px', textAlign: 'center' }}
                      value={resumenInfo.FINALIZADOS.length} disabled />}
                  </div>
                </div>
                <div className='col'>

                </div>
              </div>
              <div className='table-responsive'>
                <table className="table table-striped table-hover table-dark">
                  <thead>
                    <tr>
                      <th>COLABORADOR</th>
                      <th>FINALIZADAS</th>
                      <th>PENDIENTES</th>
                      <th>DETALLE</th>
                    </tr>
                  </thead>
                  <tbody>
                    {resumenInfo.COLABORADORES != undefined && resumenInfo.COLABORADORES.map((item, index) => {
                      return (
                        <tr key={index}>
                          <th>{item.SOLICITUDES[0].NOMBRE_COTIZ == null ? '?' : item.SOLICITUDES[0].NOMBRE_COTIZ}</th>
                          <td>{getInforResumenColab(false, item.SOLICITUDES)}</td>
                          <td>{getInforResumenColab(true, item.SOLICITUDES)}</td>
                          <td>
                            <button className='btn btn-sm btn-light' onClick={() => { setSelectLista(item.SOLICITUDES); setShowModal(true) }}>
                              <i className="fa-solid fa-ellipsis-vertical"></i>
                            </button>
                          </td>
                        </tr>
                      )
                    })}
                  </tbody>
                </table>
              </div>
              <div className='text-center fs-4 text-light bg-secondary'>Areas</div>
              <div className='table-responsive'>
                <table className="table table-striped table-hover table-dark">
                  <thead>
                    <tr>
                      <th>AREA</th>
                      <th>FINALIZADAS</th>
                      <th>PENDIENTES</th>
                      <th>DETALLE</th>
                    </tr>
                  </thead>
                  <tbody>
                    {resumenInfo.AREAS != undefined && resumenInfo.AREAS.map((item, index) => {
                      return (
                        <tr key={index}>
                          <th>{item.AREA == null ? '?' : item.AREA}</th>
                          <td>{getInforResumenColab(false, item.SOLICITUDES)}</td>
                          <td>{getInforResumenColab(true, item.SOLICITUDES)}</td>
                          <td>
                            <button className='btn btn-sm btn-light' onClick={() => { setSelectLista(item.SOLICITUDES); setShowModal(true) }}>
                              <i className="fa-solid fa-ellipsis-vertical"></i>
                            </button>
                          </td>
                        </tr>
                      )
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>}
      <Modal show={showModal} onHide={() => setShowModal(false)}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        contentClassName='bg-dark bg-gradient'>
        <Modal.Header closeButton closeVariant='white' bsPrefix='modal-header m-0 p-0 px-2'>
          <Modal.Title>
            <div className='text-light'>Lista Solicitudes</div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className='table-responsive'>
            <table className="table table-dark table-striped table-hover">
              <thead>
                <tr>
                  <th scope="col">ID</th>
                  <th scope="col">SOLICITADO</th>
                  <th scope="col">PRIORIDAD</th>
                  <th scope="col">ESTADO</th>
                </tr>
              </thead>
              <tbody>
                {selectLista.map((item, index) => {
                  console.log(item)
                  return (
                    <tr key={index}>
                      <td>{item.ID_SOLICITUD}</td>
                      <td>{DateConverter.formatoFecha(item.FECHA)}</td>
                      <td>{getPrioridad(item.PRIORIDAD)}</td>
                      <td>{item.NAME_ESTADO}</td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </div>
        </Modal.Body>
      </Modal>
    </>
  )
}

export default ReporteReuqerimiento